import { apiClient, unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type { DashboardStats } from '@/types/dashboard';

export const dashboardApi = {
  getStats(): Promise<DashboardStats> {
    return unwrap(apiClient.get<ApiResponse<DashboardStats>>('/dashboard/stats'));
  },
};
